module.exports = __webpack_public_path__ + "img/ueberdachung_2.2bf67580.jpg";